import React from 'react';
import { render } from 'react-dom';

// Dealer map - dynamic import
const dealerRoot = document.getElementById('locator-map-dealer');
if (dealerRoot) {
  import(/* webpackChunkName: "equipment-dealer-search" */ './apps/EquipmentDealerSearch')
    .then(({ default: EquipmentDealerSearch }) => {
      render(<EquipmentDealerSearch {...dealerRoot.dataset} />, dealerRoot);
    });
}

// Supplier map - dynamic import
const supplierRoot = document.getElementById('locator-map-supplier');
if (supplierRoot) {
  import(/* webpackChunkName: "propane-supplier-search" */ './apps/PropaneSupplierSearch')
    .then(({ default: PropaneSupplierSearch }) => {
      render(<PropaneSupplierSearch {...supplierRoot.dataset} />, supplierRoot);
    });
}
